// src/components/TimeCapsuleEdit.js
import React, { useState } from 'react';
import { apiFetch } from '../utils/apiFetch';
import '../styles/TimeCapsuleEdit.css';
import { useToast } from './Toast';

const TimeCapsuleEdit = ({ timeCapsule, onClose, onSuccess }) => {
    const toast = useToast();
    const [formData, setFormData] = useState({
        content: timeCapsule.content || ''
        // ✅ openDate 필드 제거
    });
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.content.trim()) {
            newErrors.content = '내용을 입력해주세요.';
        } else if (formData.content.length > 2000) {
            newErrors.content = '내용은 2000자 이하로 입력해주세요.';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setIsLoading(true);
        
        try {
            const response = await apiFetch(`/timecapsule/${timeCapsule.timecapsuleId}`, {
                method: 'PUT',
                body: JSON.stringify({
                    content: formData.content
                    // ✅ openDate 제거
                })
            });
            
            if (response.ok) {
                if (onSuccess) {
                    onSuccess();
                }
                onClose();
            } else {
                const errorData = await response.json();
                toast.error(errorData.errorMessage || errorData.message || '타임캡슐 수정에 실패했습니다.');
            }
        } catch (error) {
            console.error('타임캡슐 수정 오류:', error);
            toast.error('네트워크 오류가 발생했습니다. 다시 시도해주세요.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleModalClick = (e) => {
        if (e.target.classList.contains('timecapsule-edit-overlay')) {
            onClose();
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long'
        });
    };

    return (
        <div className="timecapsule-edit-overlay" onClick={handleModalClick}>
            <div className="timecapsule-edit-modal">
                <div className="modal-header">
                    <h2>타임캡슐 수정</h2>
                    <button onClick={onClose} className="modal-close-btn">✕</button>
                </div>

                <div className="modal-content">

                    {/* 현재 개봉 날짜 정보 표시 (수정 불가) */}
                    <div className="timecapsule-info">
                        <h4>📅 타임캡슐 정보</h4>
                        <div className="info-item">
                            <span className="info-label">개봉 예정일:</span>
                            <span className="info-value">{formatDate(timeCapsule.openDate)}</span>
                        </div>
                        <p className="info-note">💡 개봉일은 일기에서 설정한 개봉일을 따릅니다. 변경하려면 일기 수정에서 개봉일을 바꿔주세요.</p>
                    </div>

                    <form onSubmit={handleSubmit} className="timecapsule-form">
                        {/* ✅ 개봉 날짜 입력 섹션 완전 제거 */}
                        
                        <div className="form-group">
                            <label htmlFor="content" className="form-label">
                                메시지 * 💝
                            </label>
                            <textarea
                                id="content"
                                name="content"
                                value={formData.content}
                                onChange={handleInputChange}
                                className={`form-textarea ${errors.content ? 'error' : ''}`}
                                placeholder="타임캡슐 메시지를 수정해보세요..."
                                rows={10}
                                maxLength={2000}
                                autoFocus
                            />
                            {errors.content && (
                                <span className="error-text">{errors.content}</span>
                            )}
                            <small className="form-hint">
                                {formData.content.length}/2000자
                            </small>
                        </div>

                        <div className="form-actions">
                            <button 
                                type="button" 
                                className="cancel-btn"
                                onClick={onClose}
                            >
                                취소
                            </button>
                            <button 
                                type="submit" 
                                className="submit-btn"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <div className="button-spinner"></div>
                                        수정 중...
                                    </>
                                ) : (
                                    '수정 완료 🎁'
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default TimeCapsuleEdit;
